export default __webpack_public_path__ + "static/media/productValues3.fbc6bab7.svg";